import { useState, useEffect } from 'react';
import { loadContentData } from '../lib/contentStore';
import PortalHeader from '../components/PortalHeader';
import PageHeader from '../components/PageHeader';

export default function ContentManager() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadContentData()
      .then(setData)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="page"><p>Loading content data…</p></div>;
  if (error) return <div className="page"><p className="error">Error: {error}</p></div>;

  const { activePromos, clubMap, eventsByClub, clubsWithoutEvents, productPricing } = data;
  const clubIds = Object.keys(eventsByClub).sort();

  return (
    <>
      <PortalHeader />
      <div className="page">
        <PageHeader backTo="/admin" backLabel="Admin" title="Content" />

      {/* Active Promos */}
      {activePromos.length > 0 && (
        <section>
          {activePromos.map((promo) => (
            <div key={promo.key} className="promo-banner" style={{
              background: 'var(--info-bg, #e8f4fd)',
              border: '1px solid var(--info-border, #b8daff)',
              borderRadius: '6px',
              padding: '0.75rem 1rem',
              marginBottom: '0.75rem',
            }}>
              <strong>Active Promo:</strong>{' '}
              {promo.key.replace(/_/g, ' ')}
              {promo.events?.length > 0 && <> — events: {promo.events.join(', ')}</>}
              {promo.end && <> (until {promo.end})</>}
            </div>
          ))}
        </section>
      )}

      {/* Clubs & Events */}
      {clubIds.length > 0 && (
        <section>
          <h2>Clubs &amp; Events</h2>
          <table className="content-table">
            <thead>
              <tr>
                <th>Club</th>
                <th>Event</th>
                <th>Status</th>
                <th>Entitlement</th>
                <th>Product</th>
                <th>Price</th>
                <th>Dates</th>
              </tr>
            </thead>
            <tbody>
              {clubIds.map((clubId) => {
                const club = clubMap[clubId] || { name: clubId };
                const events = eventsByClub[clubId];
                return events.map((ev, i) => (
                  <tr key={`${clubId}-${ev.event_id}`}>
                    {i === 0 && (
                      <td rowSpan={events.length}><strong>{club.name}</strong></td>
                    )}
                    <td>{ev.name}</td>
                    <td>
                      <span className={`status-${ev.status}`}>
                        {ev.status.replace(/_/g, ' ')}
                      </span>
                    </td>
                    <td><code>{ev.entitlement_id || '—'}</code></td>
                    <td><code>{ev.product_id || '—'}</code></td>
                    <td>
                      {ev.product_id && productPricing[ev.product_id]
                        ? `€${productPricing[ev.product_id]}`
                        : '—'}
                    </td>
                    <td style={{ fontSize: '.75rem' }}>
                      {ev.available_date || '?'} → {ev.expires_date || '?'}
                    </td>
                  </tr>
                ));
              })}
            </tbody>
          </table>
        </section>
      )}

      {/* Clubs without events */}
      {clubsWithoutEvents.length > 0 && (
        <section>
          <h2>Clubs (no events yet)</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
            {clubsWithoutEvents.map((c) => (
              <span key={c.id} style={{
                background: 'var(--off-white, #f5f5f5)',
                color: 'var(--gray-dark, #555)',
                fontSize: '.8rem',
                padding: '.3rem .6rem',
                borderRadius: '4px',
              }}>
                {c.name}
              </span>
            ))}
          </div>
        </section>
      )}
      </div>
    </>
  );
}
